import * as React from "react";
const SellMinusIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={25}
    className="plusToggleNew"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path stroke="#979797" d="M.5.5h24v24H.5z" />
      <path fill="#1188F4" d="M5 11h15v3H5z" className="cross-h" />
    </g>
  </svg>
);
export default SellMinusIcon;
